<template>
	<div class="w-full flex flex-col">
        <div class="mb-5 w-full flex items-center border-b border-gray-200 pb-2">
            <div class="w-full flex items-center justify-between">
                <div class="flex items-center">
                    <h1 class="module-header">Utilization</h1>
                    <div
                        class="ml-4 badge px-8 py-6 w-12 h-12 flex justify-center items-center text-lg font-extrabold rounded-lg shadow-md"
                        :class="site.utilization_color"
                        title="Utilization">
                        {{ site.utilization }}%
                    </div>
                </div>
                <select v-if="leases.all.length > 1" @change="changeLease" v-model="selectedLeaseId" class="max-w-fit form-select form-select-blue text-sm">
                    <option v-for="lease in leases.all" :value="lease.id" :key="lease.id">{{ lease.name }}</option>
                </select>
            </div>
        </div>
        <div v-if="leases.selectedLease" class="space-y-4">
            <div v-if="showUsage" class="flex flex-col bg-gray-50 hover:bg-yellow-50 border border-gray-300 rounded-md">
                <div @click="expandUsage = ! expandUsage" class="p-3 flex flex-1 justify-between cursor-pointer">
                    <div class="mt-1 ml-2 flex items-center space-x-2">
                        <div class="flex">
                            <span
                                :class="{ 'rotate-0 ease-out': ! expandUsage, 'rotate-90 ease-in': expandUsage }"
                                class="transform transition-transform duration-100"
                            >
                                <inline-svg name="chevron-right" classes="w-8 h-8 text-gray-500 fill-current"></inline-svg>
                            </span>
                        </div>
                        <div class="mb-1 text-2xl text-gray-700 font-extrabold">Usage</div>
                    </div>
                    <div class="p-4"></div>
                </div>
                <div v-if="expandUsage" class="bg-gray-100 border-t rounded-b">
                    <lease-usage
                        @updateUtilization='sites.selectedSite = $event'
                        show-save-button
                        :from-reatlas="fromReatlas"
                    ></lease-usage>
                </div>
            </div>
            <div v-if="leases.selectedLease?.office_percentage > 0" class="flex flex-col bg-gray-50 hover:bg-yellow-50 border border-gray-300 rounded-md">
                <div @click="showOffice = ! showOffice" class="p-3 flex flex-1 justify-between cursor-pointer">
                    <div class="mt-1 ml-2 flex items-center space-x-2">
                        <div class="flex">
                            <span
                                :class="{ 'rotate-0 ease-out': ! showOffice, 'rotate-90 ease-in': showOffice }"
                                class="transform transition-transform duration-100"
                            >
                                <inline-svg name="chevron-right" classes="w-8 h-8 text-gray-500 fill-current"></inline-svg>
                            </span>
                        </div>
                        <div class="mb-1 text-2xl text-gray-700 font-extrabold">Office</div>
                    </div>

                    <div class="p-4 flex items-center rounded-sm space-x-2" :class="getUtilizationColor(officeUtilization)">
                        <span class="text-xl font-extrabold">{{ officeUtilization }}%</span>
                        <span class="text-lg font-variant-all-small-caps">Utilized</span>
                    </div>
                </div>

                <div v-if="showOffice" class="bg-gray-100 border-t rounded-b">
                    <div class="p-4">
                        <div v-if="headCount == 0" class="mb-4 alert orange">Office Utilization cannot be calculated until you enter your current Employee Count</div>
                        <div class="grid grid-cols-3 gap-x-4">
                            <div class="p-5 bg-gray-50 border">
                                <!-- <div class="flex flex-col items-center justify-center space-y-3">
                                    <span class="text-2xl font-extrabold">{{ sites.selectedSite.office_allowable_waste_percentage }}%</span>
                                    <input
                                        @change="save"
                                        v-model.number="sites.selectedSite.office_allowable_waste_percentage"
                                        class="mt-3 range-green"
                                        type="range"
                                        min="0"
                                        max="30"
                                        step="1" />
                                    <span
                                        class="ml-2 font-variant-all-small-caps"
                                        :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                            Allowable Waste
                                    </span>
                                </div> -->

                                <div class="flex flex-col items-center justify-center space-y-3 w-full relative">
                                    <div class="flex items-center justify-center w-full relative">
                                        <span class="text-2xl font-extrabold">{{ sites.selectedSite.office_allowable_waste_percentage }}%</span>
                                        <div class="absolute right-0">
                                            <InfoIcon identifier="sites-utilizationtab-office-allowablewaste" />
                                        </div>
                                    </div>
                                    
                                    <input
                                        @change="save"
                                        v-model.number="sites.selectedSite.office_allowable_waste_percentage"
                                        class="mt-3 range-green"
                                        type="range"
                                        min="0"
                                        max="30"
                                        step="1" />

                                    <span
                                        class="ml-2 font-variant-all-small-caps"
                                        :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                        Allowable Waste
                                    </span>
                                </div>

                            </div>

                            <div>
                                <div class="p-5 bg-gray-50 border">
                                    <!-- <div class="flex flex-col items-center justify-center space-y-3">
                                        <p class="text-2xl font-extrabold">{{ sites.selectedSite.employees_ideal_square_footage }}</p>
                                        <input
                                            @change="save"
                                            v-model.number="sites.selectedSite.employees_ideal_square_footage"
                                            class="mt-3 range-green"
                                            type="range"
                                            min="100"
                                            max="500"
                                            step="5" />
                                        <p
                                            class="ml-2 font-variant-all-small-caps"
                                            :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                                Ideal Density
                                        </p>
                                    </div> -->
                                    <div class="flex flex-col items-center justify-center space-y-3 w-full relative">
                                        <div class="flex items-center justify-center w-full relative">
                                            <p class="text-2xl font-extrabold">{{ sites.selectedSite.employees_ideal_square_footage }}</p>
                                            <div class="absolute right-0">
                                                <InfoIcon identifier="sites-utilizationtab-office-idealdensity" />
                                            </div>
                                        </div>

                                        <input
                                            @change="save"
                                            v-model.number="sites.selectedSite.employees_ideal_square_footage"
                                            class="mt-3 range-green"
                                            type="range"
                                            min="100"
                                            max="500"
                                            step="5" />

                                        <p
                                            class="ml-2 font-variant-all-small-caps"
                                            :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                            Ideal Density
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <!-- <div class="p-3 lg:p-5 h-full flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                    <span class="text-2xl font-extrabold">{{ squareFootagePerEmployee | number }}</span>
                                    <span
                                        class="text-center font-variant-all-small-caps"
                                        :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                            Sq. Ft. Per Employee
                                    </span>
                                </div> -->
                                <div class="p-3 lg:p-5 h-full flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                    <div class="w-full flex justify-end items-center space-x-2">
                                        <span class="text-2xl font-extrabold">{{ squareFootagePerEmployee | number }}</span>
                                        <InfoIcon identifier="sites-utilizationtab-office-sq.ft.peremployee" />
                                    </div>

                                    <span
                                        class="text-center font-variant-all-small-caps"
                                        :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                        Sq. Ft. Per Employee
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="mt-8">
                            <employee-counts :site-id="sites.selectedSite.id" :data="sites.selectedSite.employee_counts" :show-chart="false"></employee-counts>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="leases.selectedLease?.industrial_percentage > 0" class="flex flex-col bg-gray-50 hover:bg-yellow-50 border border-gray-300 rounded-md">
                <div @click="showIndustrial = ! showIndustrial" class="p-3 flex flex-1 justify-between cursor-pointer">
                    <div class="mt-1 ml-2 flex items-center space-x-3">
                        <div class="flex">
                            <span
                                :class="{ 'rotate-0 ease-out': ! showIndustrial, 'rotate-90 ease-in': showIndustrial }"
                                class="transform transition-transform duration-100"
                            >
                                <inline-svg name="chevron-right" classes="w-8 h-8 text-gray-500 fill-current"></inline-svg>
                            </span>
                        </div>
                        <div class="mb-1 text-2xl text-gray-700 font-extrabold">Industrial</div>
                    </div>

                    <div class="p-4 flex items-center rounded-sm space-x-2" :class="getUtilizationColor(industrialUtilization)">
                        <span class="text-xl font-extrabold">{{ industrialUtilization }}%</span>
                        <span class="text-lg font-variant-all-small-caps">Utilized</span>
                    </div>
                </div>

                <div v-if="showIndustrial" class="bg-gray-100 border-t rounded-b">
                    <div class="p-4 lg:p-8 flex flex-col">
                        <div class="grid gap-3 lg:gap-6" :class="showIndustrialChart ? 'grid-cols-4' : 'grid-cols-2'">
                            <!-- <div>
                                <div class="p-6 h-full flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                    <number-input v-model="sites.selectedSite.rack_max" @input="changeMaxRacks($event)" classes="text-xl lg:text-3xl text-center font-extrabold"></number-input>
                                    <span class="text-base lg:text-2xl font-variant-all-small-caps">Max Racks</span>
                                </div>
                            </div> -->
                            <div class="relative">
                                <div class="absolute right-2 top-2">
                                    <InfoIcon identifier="sites-utilizationtab-industrial-maxracks" />
                                </div>

                                <div class="p-6 h-full flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                    <number-input 
                                        v-model="sites.selectedSite.rack_max" 
                                        @input="changeMaxRacks($event)" 
                                        classes="text-xl lg:text-3xl text-center font-extrabold">
                                    </number-input>

                                    <span class="text-base lg:text-2xl font-variant-all-small-caps">Max Racks</span>
                                </div>
                            </div>

                            <!-- <div class="p-5 bg-gray-50 border">
                                <div class="h-full flex flex-col items-center justify-center space-y-3">
                                    <p class="text-2xl font-extrabold">{{ sites.selectedSite.industrial_allowable_waste_percentage }}%</p>
                                    <input
                                        @change="save"
                                        v-model.number="sites.selectedSite.industrial_allowable_waste_percentage"
                                        class="mt-3 range-green"
                                        type="range"
                                        min="0"
                                        max="30"
                                        step="1" />
                                    <p class="ml-2 text-base lg:text-2xl font-variant-all-small-caps">Allowable Waste</p>
                                </div>
                            </div> -->
                            <div class="relative">
                                <div class="absolute right-2 top-2">
                                    <InfoIcon identifier="sites-utilizationtab-industrial-allowablewaste" />
                                </div>

                                <div class="p-5 bg-gray-50 border">
                                    <div class="h-full flex flex-col items-center justify-center space-y-3">
                                        <p class="text-2xl font-extrabold">{{ sites.selectedSite.industrial_allowable_waste_percentage }}%</p>
                                        <input
                                            @change="save"
                                            v-model.number="sites.selectedSite.industrial_allowable_waste_percentage"
                                            class="mt-3 range-green"
                                            type="range"
                                            min="0"
                                            max="30"
                                            step="1" />
                                        <p class="ml-2 text-base lg:text-2xl font-variant-all-small-caps">Allowable Waste</p>
                                    </div>
                                </div>
                            </div>


                            <!-- <div class="p-3 lg:p-5 flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                <span class="text-xl lg:text-3xl font-extrabold">{{ industrialUsedSpace | number }}</span>
                                <span class="text-base lg:text-2xl font-variant-all-small-caps">Used Space</span>
                            </div> -->

                            <div class="relative">
                                <div class="absolute right-2 top-2">
                                    <InfoIcon identifier="sites-utilizationtab-industrial-usedspace" />
                                </div>

                                <div class="p-3 lg:p-5 flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                    <span class="text-xl lg:text-3xl font-extrabold">{{ industrialUsedSpace | number }}</span>
                                    <span class="text-base lg:text-2xl font-variant-all-small-caps">Used Space</span>
                                </div>
                            </div>


                            <!-- <div class="p-3 lg:p-5 flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                <span class="text-xl lg:text-3xl font-extrabold">{{ industrialAvailableSpace | number }}</span>
                                <span class="text-base lg:text-2xl font-variant-all-small-caps">Available Space</span>
                            </div> -->
                            <div class="relative">
                                <div class="absolute right-2 top-2">
                                    <InfoIcon identifier="sites-utilizationtab-industrial-availablespace" />
                                </div>

                                <div class="p-3 lg:p-5 flex flex-col items-center justify-center bg-gray-50 border space-y-2">
                                    <span class="text-xl lg:text-3xl font-extrabold">{{ industrialAvailableSpace | number }}</span>
                                    <span class="text-base lg:text-2xl font-variant-all-small-caps">Available Space</span>
                                </div>
                            </div>

                        </div>

                        <div v-if="sites.selectedSite.rack_max > 0" class="mt-10 flex flex-col lg:flex-row justify-between">
                            <div :class="showIndustrialChart ? 'w-1/3' : 'w-full'">
                                <table class="w-full">
                                    <thead>
                                        <tr>
                                            <th class="pl-4 text-center">Level</th>
                                            <th class="text-right">Used %</th>
                                            <th class="text-right">Used Sq. Ft.</th>
                                            <th class="text-right">Max. Sq. Ft</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(rack, index) in racks" :key="'rack-' + rack.level + '-' + index">
                                            <td class="pl-4 text-center">{{ rack.level }}</td>
                                            <td class="text-right">
                                                {{ calculateRackUsePercentage(rack) }}%
                                            </td>
                                            <td>
                                                <number-input v-model="rack.used_square_footage" :size="7" justify-end></number-input>
                                            </td>
                                            <td>
                                                <number-input v-model="rack.max_square_footage" :size="7" justify-end></number-input>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <button @click.prevent="save" type="button" class="mt-5 self-end btn btn-green">Save Racks</button>
                            </div>

                            <div v-if="showIndustrialChart" class="w-2/3 lg:ml-10 flex-1">
                                <pie-chart
                                    :data="industrialChartData"
                                    height="480"
                                    ref="industrialChart"
                                    legend-font-color="#4b5563"
                                    bg-color="#ffffff"
                                    smart-line-color="#4b5563"
                                    label-font-color="#4b5563">
                                </pie-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col bg-gray-50 hover:bg-yellow-50 border border-gray-300 rounded-md">
                <div @click="showWaste = ! showWaste" class="p-3 flex flex-1 justify-between cursor-pointer">
                    <div class="mt-1 ml-2 flex items-center space-x-2">
                        <div class="flex">
                            <span
                                :class="{ 'rotate-0 ease-out': ! showWaste, 'rotate-90 ease-in': showWaste }"
                                class="transform transition-transform duration-100"
                            >
                                <inline-svg name="chevron-right" classes="w-8 h-8 text-gray-500 fill-current"></inline-svg>
                            </span>
                        </div>
                        <div class="mb-1 text-2xl text-gray-700 font-extrabold">Waste</div>
                    </div>
                </div>
                <div v-if="showWaste" class="bg-gray-100 border-t rounded-b">
                    <div class="p-4">
                        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                            <div class="p-4 bg-white rounded border">
                                <div class="flex justify-between items-center mb-2">
                                    <div class="flex items-center">
                                        <label class="block text-sm font-medium text-gray-700">NPV Discount %</label>
                                        <InfoIcon identifier="sites-waste-npvdiscount" />
                                    </div>
                                    <span class="text-sm font-semibold text-gray-900">{{ site.npv_discount_rate }}%</span>
                                </div>
                                <div class="text-xs text-gray-500">Set for the whole portfolio in client settings</div>
                            </div>

                            <div class="p-4 bg-white rounded border">
                                <div class="flex justify-between items-center mb-2">
                                    <label class="block text-sm font-medium text-gray-700">NPV</label>
                                    <span>{{ site?.npv ? Math.round(site.npv) : 0 }}</span>
                                </div>
                                <div class="text-xs text-gray-500">Net Present Value</div>
                            </div>

                            <div class="p-4 bg-white rounded border">
                                <div class="flex justify-between items-center mb-2">
                                    <label class="block text-sm font-medium text-gray-700">NPV PSF</label>
                                    <span>{{ site?.npv_psf ? Math.round(site.npv_psf) : 0 }}</span>
                                </div>
                                <div class="text-xs text-gray-500">NPV per square foot</div>
                            </div>

                            <div class="p-4 bg-white rounded border">
                                <div class="flex justify-between items-center mb-2">
                                    <label class="block text-sm font-medium text-gray-700">NPV per Seat</label>
                                    <span>{{ site?.npv_per_seat ? Math.round(site.npv_per_seat) : 0 }}</span>
                                </div>
                                <div class="text-xs text-gray-500">NPV per seat</div>
                            </div>
                        </div>
                        
                        <div class="mt-6 flex justify-end">
                            <button 
                                @click="save"
                                :disabled="isSaving"
                                class="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                <span v-if="isSaving" class="flex items-center">
                                    <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Saving...
                                </span>
                                <span v-else>Save Changes</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="leases.selectedLease?.manufacturing_percentage > 0" class="flex flex-col bg-gray-50 hover:bg-yellow-50 border border-gray-300 rounded-md">
                <div @click="showManufacturing = ! showManufacturing" class="p-3 flex flex-1 justify-between cursor-pointer">
                    <div class="mt-1 ml-2 flex items-center space-x-3">
                        <div class="flex">
                            <span
                                :class="{ 'rotate-0 ease-out': ! showManufacturing, 'rotate-90 ease-in': showManufacturing }"
                                class="transform transition-transform duration-100"
                            >
                                <inline-svg name="chevron-right" classes="w-8 h-8 text-gray-500 fill-current"></inline-svg>
                            </span>
                        </div>
                        <div class="mb-1 text-2xl text-gray-700 font-extrabold">Manufacturing</div>
                    </div>

                    <div class="p-4 flex items-center rounded-sm space-x-2" :class="getUtilizationColor(manufacturingUtilization)">
                        <span class="text-xl font-extrabold">{{ manufacturingUtilization }}%</span>
                        <span class="text-lg font-variant-all-small-caps">Utilized</span>
                    </div>
                </div>

                <div v-if="showManufacturing" class="bg-gray-100 border-t rounded-b">
                    <div class="p-4 lg:p-8">
                        <div class="grid grid-cols-3 gap-3 lg:gap-6">
                            <div class="p-5 bg-gray-50 border">
                                <div class="h-full flex flex-col items-center justify-center space-y-3">
                                    <p class="text-2xl font-extrabold">{{ sites.selectedSite.manufacturing_allowable_waste_percentage }}%</p>
                                    <input
                                        @change="save"
                                        v-model.number="sites.selectedSite.manufacturing_allowable_waste_percentage"
                                        class="mt-3 range-green"
                                        type="range"
                                        min="0"
                                        max="30"
                                        step="1" />
                                    <p
                                        class="mt-2 text-center font-variant-all-small-caps"
                                        :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                            Allowable Waste
                                    </p>
                                </div>
                            </div>

                            <div class="h-full p-5 bg-gray-50 border">
                                <div class="h-full flex flex-col items-center justify-center space-y-3">
                                    <p class="text-xl lg:text-3xl font-extrabold">{{ sites.selectedSite.manufacturing_used_square_footage | number }}</p>
                                    <input
                                        @change="save"
                                        v-model.number="sites.selectedSite.manufacturing_used_square_footage"
                                        class="mt-3 range-green"
                                        type="range"
                                        min="0"
                                        :max="sites.selectedSite.manufacturing_square_footage"
                                        step="1" />
                                    <p
                                        class="mt-2 text-center font-variant-all-small-caps"
                                        :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                            Used Sq. Ft.
                                    </p>
                                </div>
                            </div>

                            <div class="p-5 lg:p-10 flex flex-col items-center justify-center text-center bg-gray-50 border space-y-2">
                                <span class="text-xl lg:text-3xl font-extrabold">{{ sites.selectedSite.manufacturing_square_footage | number }}</span>
                                <span
                                    class="mt-2 text-center font-variant-all-small-caps"
                                    :class="{ 'text-base': fromReatlas, 'text-base lg:text-2xl': ! fromReatlas }">
                                        Available Space
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="none-found">Waiting for Lease Information</div>
	</div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
    	props: {
            showUsage: {
                type: Boolean,
                default: true
            },

            showIndustrialChart: {
                type: Boolean,
                default: true
            },

            fromReatlas: {
                type: Boolean,
                default: false
            }
    	},

    	data() {
    		return {
                expandUsage: false,
                showOffice: false,
                showIndustrial: false,
                showManufacturing: false,
                showWaste: false,
                isSaving: false,
                selectedLeaseId: null,
                racks: {}
    		}
    	},

        mounted() {
            this.$nextTick(() => {
                this.selectedLeaseId = this.leases?.selectedLease?.id || null;

                if (_.isEmpty(this.site.rack_data)) {
                    this.generateRackData();
                } else {
                    this.racks = this.site.rack_data;
                }
            });
        },

        computed: {
            ...mapState(['sites']),
            ...mapState(['leases']),

            site: {
                get() {
                    return this.sites.selectedSite;
                },
                set(value) {
                    // Update the site in the Vuex store
                    this.$store.commit('UPDATE_SITE', value);
                }
            },

            headCount() {
                return this.site.head_count;

                // let latestHeadCount = this.site.employee_counts != null
                //     ? this.site.employee_counts[0]
                //     : 0;
                //
                // return _.size(latestHeadCount)
                //     ? parseInt(latestHeadCount['cte']) + parseInt(latestHeadCount['fte'])
                //     : 0;
            },

            squareFootagePerEmployee() {
                return this.site.square_footage_per_employee;

                // if (isNaN(this.site.size) || this.headCount == 0) {
                //     return 0;
                // }
                //
                // return Math.round(this.site.office_square_footage / this.headCount);
            },

            officeUtilization() {
                let idealDensity = parseInt(this.site.employees_ideal_square_footage);

                if (isNaN(idealDensity) || this.headCount == 0) {
                    return 0;
                }

                return Math.round(
                    ((idealDensity / (this.site.office_square_footage / this.headCount)) + (this.site.office_allowable_waste_percentage / 100))
                * 100);
            },

            industrialUtilization() {
                if (this.industrialAvailableSpace == 0) {
                    return 0;
                }

                return Math.round(
                    ((this.industrialUsedSpace / this.industrialAvailableSpace) + (this.site.industrial_allowable_waste_percentage / 100))
                * 100);
            },

            industrialAvailableSpace() {
                return _.sum(
                    _.map(this.racks, (rack) => {
                        let maxSquareFootage = Number.prototype.cleanseInteger(rack.max_square_footage);

                        return isNaN(maxSquareFootage) ? 0 : maxSquareFootage;
                    })
                );
            },

            industrialUsedSpace() {
                return _.sum(
                    _.map(this.racks, (rack) => {
                        let usedSquareFootage = Number.prototype.cleanseInteger(rack.used_square_footage);

                        return isNaN(usedSquareFootage) ? 0 : usedSquareFootage;
                    })
                );
            },

            industrialChartData() {
                return [
                    {
                        label: 'Used',
                        value: this.industrialUsedSpace
                    },
                    {
                        label: 'Remaining',
                        value: this.industrialAvailableSpace - this.industrialUsedSpace
                    }
                ];
            },

            manufacturingUtilization() {
                if (this.site.manufacturing_square_footage == 0) {
                    return 0;
                }

                return Math.round(
                    ((this.site.manufacturing_used_square_footage / this.site.manufacturing_square_footage) + (this.site.manufacturing_allowable_waste_percentage / 100))
                * 100);
            },
        },

        methods: {
            calculateRackUsePercentage(rack) {
                let maxSquareFootage = Number.prototype.cleanseInteger(rack.max_square_footage);
                let usedSquareFootage = Number.prototype.cleanseInteger(rack.used_square_footage);

                if (isNaN(usedSquareFootage) || isNaN(maxSquareFootage)) {
                    return 0;
                }

                return Math.round((usedSquareFootage / maxSquareFootage) * 100);
            },

            generateRackData() {
                this.$nextTick(() => {
                    this.racks = _.keyBy(
                        _.map(_.range(0, this.site.rack_max), (value, key) => {
                            return {
                                'level': value + 1,
                                'used_percentage': 0,
                                'used_square_footage': 0,
                                'max_square_footage': Number.prototype.cleanseInteger(this.site.industrial_square_footage)
                            }
                        }),
                    'level');
                })
            },

            changeMaxRacks(numberOfRacks) {
                let currentRackSize = parseInt(_.size(this.racks));

                if (numberOfRacks < currentRackSize) {
                    _.times(currentRackSize - numberOfRacks, () => {
                        delete this.racks[_.findLastKey(this.racks)];
                    });

                    this.racks = _.keyBy(this.racks, 'level');

                } else if (numberOfRacks > currentRackSize) {
                    var currentLevel = currentRackSize;

                    _.times(numberOfRacks - currentRackSize, () => {
                        currentLevel += 1;

                        this.racks[currentLevel] = {
                            'level': currentLevel,
                            'used_percentage': 0,
                            'used_square_footage': 0,
                            'max_square_footage': Number.prototype.cleanseInteger(this.site.industrial_square_footage)
                        };
                    });

                    this.racks = _.keyBy(this.racks, 'level');
                }

                this.save();
            },

            getUtilizationColor(utilization) {
                if (utilization > 100) {
                    return 'badge-purple';
                }

                if (utilization >= 90) {
                    return 'badge-green';
                }

                if (utilization >= 70) {
                    return 'badge-yellow';
                }

                return 'badge-red';
            },

            changeLease() {
                this.expandUsage = true;

                this.leases.selectedLease = _.find(this.site.leases, ['id', this.selectedLeaseId]);
            },

            save() {
                this.site.rack_data = this.racks;
                
                // Create a clean object with only the fields we want to update
                const dataToUpdate = {
                    rack_data: this.racks,
                    _method: 'PATCH' // Ensure we're sending a PATCH request
                };

                this.isSaving = true;
                
                axios.patch('/sites/' + this.site.id, dataToUpdate)
                    .then(response => {
                        this.$eventHub.$emit('site-saved', response.data.site);

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response?.data?.message || 'An error occurred while saving.'
                        });
                        console.error('Error saving site:', error);
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            }
        }
    }
</script>
